export interface CreditMeterProps {
  credits?: number;
  state?: "healthy" | "low";
  locale?: string;
}

/** Credit meter for the top bar. Numerals are mono, per brand spec. */
export function CreditMeter({ credits = 1247, state = "healthy", locale }: CreditMeterProps) {
  const color = state === "low" ? "#F59E0B" : "var(--fg)";
  const dotColor = state === "low" ? "#F59E0B" : "#FF2D1F";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        height: 32,
        padding: "0 14px",
        borderRadius: 9999,
        border: "1px solid var(--border)",
        fontFamily: 'Geist Mono, "Söhne Mono", monospace',
        fontSize: 13,
        color,
      }}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill={dotColor} aria-hidden>
        <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
      </svg>
      {credits.toLocaleString(locale)}
    </span>
  );
}
